<div class="profile-control-header aza-align-items-baseline">
    <section class="section-h1 aza-section aza-theme">
        <div class="aza-section-content aza-section-colors">
            <div class="aza-text aza-heading">
                <span>{{titleTranslationKey | translate}}</span>
            </div>
        </div>
    </section>
    <ng-content></ng-content>
    <button (click)="onClosed()" class="profile-control-action profile-control-action-close">
        <img src="./assets/img/clear_black_24dp.svg" />
    </button>
</div>
